class SmoothScroll {
  constructor(el, opt) {
    this.el = el;
    this.event();
  }
  event() {

    const urlHash = location.hash;
    if(urlHash) {
      $('body,html').stop().scrollTop(0);
      setTimeout(function(){
        const target = $(urlHash);
        const position = target.offset().top + -30;
        $('body,html').stop().animate({scrollTop:position}, 500);
      }, 100);
    }
    $('a[href^="#"]').click(function(){
      const href= $(this).attr("href");
      const target = $(href);
      const position = target.offset().top + -30;
      $('body,html').stop().animate({scrollTop:position}, 500);
      return false;
    });
  }
}
